import { memo, useCallback } from 'react';

import { CircleCheckIcon, MessageCircleCheckIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { type CommentMenuProps } from '~/components/DiscussionsV2/Discussion/DiscussionComment/components/CommentMenu';
import { useHover } from '~/hooks/useHover';

export type ReopenDiscussionButtonProps = {
  onToggleResolve: CommentMenuProps['onToggleResolve'];
  discussion: ClipDiscussion;
};

export const ReopenDiscussionButton = memo(({ onToggleResolve, discussion }: ReopenDiscussionButtonProps) => {
  const { handleUnhover, handleHover, isHovering } = useHover();

  const handleToggleResolveClick = useCallback(() => {
    onToggleResolve?.({
      annotation: discussion.annotation,
      clipId: discussion.clipId,
      id: discussion.id,
      resolved: !discussion.resolved,
      timestamp: discussion.timestamp,
    });
  }, [discussion, onToggleResolve]);

  return (
    <Button
      data-testid="REOPEN_DISCUSSION_BUTTON"
      onMouseEnter={handleHover}
      onMouseLeave={handleUnhover}
      prefix={isHovering ? <MessageCircleCheckIcon size="xs" /> : <CircleCheckIcon size="xs" />}
      className="ml-1 ads:text-metadata text-gray-9 group-hover/discussions-comment:text-white"
      appearance="ghost"
      color="gray"
      size="small"
      onClick={handleToggleResolveClick}
    >
      Re-open
    </Button>
  );
});

ReopenDiscussionButton.displayName = 'ReopenDiscussionButton';
